const nourishmentData =
{
  "vitamin-a": {
    "weight": 1.6,
    "labelWeightNumber": 1600,
    "labelWeightUnit": "mcg",
    "labelWeight": "1600mcg",
    "NRV": "200%",
    "NRVNumber": 200,
    "ingredient": "Vitamin A Acetate",
    "title": "Vitamin A",
    "color": "#9f3e52",
    "titleJA": "ビタミンA",
    "ingredientJA": "ビタミンAアセテート",
  },
  "vitamin-e": {
    "weight": 24,
    "labelWeightNumber": 24,
    "labelWeightUnit": "mg",
    "labelWeight": "24mg",
    "NRV": "200%",
    "NRVNumber": 200,
    "ingredient": "Vitamin E (DL - Alpha Tocopheryl) Acetate",
    "title": "Vitamin E",
    "color": "#764255",
    "titleJA": "ビタミンE",
    "ingredientJA": "ビタミン E (DL - アルファ トコフェロール) アセテート",
  },
  "b12": {
    "weight": 0.0025,
    "labelWeightNumber": 2.5,
    "labelWeightUnit": "mcg",
    "labelWeight": "2.5mcg",
    "NRV": "104%",
    "NRVNumber": 104,
    "ingredient": "Vitamin B12",
    "title": "Vitamin B12",
    "color": "#90a3a7",
    "titleJA": "ビタミンB12（シアノコバラミン）",
    "ingredientJA": "ビタミンB12",
  },
  "ginger-extract": {
    "weight": 100,
    "labelWeightNumber": 100,
    "labelWeightUnit": "mg",
    "labelWeight": "100mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Ginger (5% gingerols)",
    "title": "Ginger Extract",
    "color": "#844013",
    "titleJA": "ショウガエキス",
    "ingredientJA": "ショウガ（ジンゲロール5％）",
  },
  "ginger-kids": {
    "weight": 100,
    "labelWeightNumber": 100,
    "labelWeightUnit": "mg",
    "labelWeight": "100mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Ginger (5% gingerols)",
    "sanitisedName": "Ginger",
    "color": "#844013",
  },
  "iron": {
    "weight": 12,
    "labelWeightNumber": 12,
    "labelWeightUnit": "mg",
    "labelWeight": "12mg",
    "NRV": "85%",
    "NRVNumber": 85,
    "ingredient": "Ferrous Citrate",
    "title": "Iron",
    "color": "#05617d",
    "titleJA": "鉄",
    "ingredientJA": "クエン酸第一鉄",
  },
  "hydrocurc-pepperine": {
    "weight": 96,
    "labelWeightNumber": 95,
    "labelWeightUnit": "mg",
    "labelWeight": "95mg",
    "additionalLabelWeight": " Curcurmin 1mg Black pepper extract",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Hydrocurc Curcurmin (standardised to contain min 85% curcminoids), Black pepper extract",
    "title": "HydroCurc™ & Black Pepper Extract",
    "color": "#ec630c",
    "titleJA": "HydroCurc™ & ブラックペッパーエキス",
    "ingredientJA": "Hydrocurc クルクルミン (最小 85% のクルクミノイドを含むように標準化)、黒コショウ抽出物",
  },
  "hydrocurc-pepperine-kids": {
    "weight": 96,
    "labelWeightNumber": 95,
    "labelWeightUnit": "mg",
    "labelWeight": "95mg",
    "additionalLabelWeight": " Curcurmin 1mg Black pepper extract",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Hydrocurc Curcurmin (standardised to contain min 85% curcminoids), Black pepper extract",
    "sanitisedName": "HydroCurc™ & Black Pepper Extract",
    "color": "#ec630c",
  },
  "k2-vital-delta": {
    "weight": 0.075,
    "labelWeightNumber": 75,
    "labelWeightUnit": "mcg",
    "labelWeight": "75mcg",
    "NRV": "100%",
    "NRVNumber": 100,
    "ingredient": "K2 Vital Delta",
    "title": "K2 Vital Delta™",
    "color": "#e61572",
    "titleJA": "K2 Vital Delta™",
    "ingredientJA": "K2 Vital Delta™",
  },
  "coq10": {
    "weight": 30,
    "labelWeightNumber": 30,
    "labelWeightUnit": "mg",
    "labelWeight": "30mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "COQ10",
    "title": "CoQ10",
    "color": "#f4991c",
    "titleJA": "CoQ10",
    "ingredientJA": "CoQ10",
  },
  "tart-cherry": {
    "weight": 100,
    "labelWeightNumber": 100,
    "labelWeightUnit": "mg",
    "labelWeight": "100mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Tart Cherry Extract",
    "title": "Tart Cherry",
    "color": "#9b6473",
    "titleJA": "タルトチェリー",
    "ingredientJA": "タルトチェリーエキス",
  },
  "tart-cherry-kids": {
    "weight": 100,
    "labelWeightNumber": 100,
    "labelWeightUnit": "mg",
    "labelWeight": "100mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Tart Cherry Extract",
    "sanitisedName": "Tart Cherry Extract",
    "color": "#9b6473",
  },
  "beta-glucan": {
    "weight": 50,
    "labelWeightNumber": 50,
    "labelWeightUnit": "mg",
    "labelWeight": "50mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Beta Glucan",
    "title": "Beta Glucan",
    "color": "#7c77b3",
    "titleJA": "ベータグルカン",
    "ingredientJA": "ベータグルカン",
  },
  "beta-glucan-kids": {
    "weight": 50,
    "labelWeightNumber": 50,
    "labelWeightUnit": "mg",
    "labelWeight": "50mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Beta Glucan",
    "sanitisedName": "Beta Glucan",
    "color": "#7c77b3",
  },
  "white-kidney-extract": {
    "weight": 100,
    "labelWeightNumber": 100,
    "labelWeightUnit": "mg",
    "labelWeight": "100mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "White Kidney Extract",
    "title": "White Kidney Extract",
    "color": "#efd200",
    "titleJA": "ホワイトキドニービーンズエキス",
    "ingredientJA": "白い腎臓エキス",
  },
  "milk-thistle-extract": {
    "weight": 100,
    "labelWeightNumber": 100,
    "labelWeightUnit": "mg",
    "labelWeight": "100mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Milk Thistle Extract",
    "title": "Milk Thistle Extract",
    "color": "#cc7912",
    "titleJA": "ミルクシスルエキス",
    "ingredientJA": "ミルクシスルエキス",
  },
  "resveratrol": {
    "weight": 100,
    "labelWeightNumber": 100,
    "labelWeightUnit": "mg",
    "labelWeight": "100mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Resveratrol (min 98%)",
    "title": "Resveratrol",
    "color": "#aba9b6",
    "titleJA": "レスベラトロール",
    "ingredientJA": "レスベラトロール (最低 98%)",
  },
  "zinc": {
    "weight": 10,
    "labelWeightNumber": 10,
    "labelWeightUnit": "mg",
    "labelWeight": "10mg",
    "NRV": "100%",
    "NRVNumber": 100,
    "ingredient": "Zinc Citrate",
    "title": "Zinc",
    "color": "#5389aa",
    "titleJA": "亜鉛",
    "ingredientJA": "クエン酸亜鉛",
  },
  "vitamin-c": {
    "weight": 96,
    "labelWeightNumber": 96,
    "labelWeightUnit": "mg",
    "labelWeight": "96mg",
    "NRV": "120%",
    "NRVNumber": 120,
    "ingredient": "Vitamin C",
    "title": "Vitamin C",
    "color": "#f39f22",
    "titleJA": "ビタミンC",
    "ingredientJA": "ビタミンC",
  },
  "folic-acid": {
    "weight": 0.4,
    "labelWeightNumber": 400,
    "labelWeightUnit": "mcg",
    "labelWeight": "400mcg",
    "NRV": "200%",
    "NRVNumber": 200,
    "ingredient": "Folic acid (B9)",
    "title": "Folic acid",
    "color": "#4db160",
    "titleJA": "葉酸",
    "ingredientJA": "葉酸（B9）",
  },
  "cordyceps": {
    "weight": 100,
    "labelWeightNumber": 100,
    "labelWeightUnit": "mg",
    "labelWeight": "100mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Cordyceps extract",
    "title": "Cordyceps",
    "color": "#725026",
    "titleJA": "冬虫夏草",
    "ingredientJA": "冬虫夏草エキス",
  },
  "lycopene": {
    "weight": 10,
    "labelWeightNumber": 10,
    "labelWeightUnit": "mg",
    "labelWeight": "10mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Lycopene Extract",
    "title": "Lycopene",
    "color": "#7f0600",
    "titleJA": "リコピン",
    "ingredientJA": "リコピンエキス",
  },
  "lycopene-kids": {
    "weight": 100,
    "labelWeightNumber": 100,
    "labelWeightUnit": "mg",
    "labelWeight": "100mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Lycopene Extract",
    "sanitisedName": "Lycopene",
    "color": "#7f0600",
  },
  "beetroot-powder": {
    "weight": 100,
    "labelWeightNumber": 100,
    "labelWeightUnit": "mg",
    "labelWeight": "100mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Beetroot powder",
    "title": "Beetroot",
    "color": "#631025",
    "titleJA": "ビートルート",
    "ingredientJA": "ビーツパウダー",
  },
  "beetroot-kids": {
    "weight": 100,
    "labelWeightNumber": 100,
    "labelWeightUnit": "mg",
    "labelWeight": "100mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Beetroot powder",
    "sanitisedName": "Beetroot",
    "color": "#631025",
  },
  "lactospore-probiotic": {
    "weight": 17.33,
    "labelWeightNumber": 200,
    "labelWeightUnit": " Million CFU",
    "labelWeight": "200 Million CFU",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Lactospore Probiotic",
    "title": "LactoSpore® Probiotic",
    "color": "#b7bf0c",
    "titleJA": "LactoSpore® プロバイオティクス",
    "ingredientJA": "LactoSpore® プロバイオティクス",
  },
  "lactospore-probiotic-kids": {
    "weight": 17.33,
    "labelWeightNumber": 200,
    "labelWeightUnit": " Million CFU",
    "labelWeight": "200 Million CFU",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Lactospore Probiotic",
    "sanitisedName": "Lactospore Probiotic",
    "color": "#b7bf0c",
  },
  "silica": {
    "weight": 100,
    "labelWeightNumber": 100,
    "labelWeightUnit": "mg",
    "labelWeight": "100mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Silica (Bamboo extract)",
    "title": "Silica",
    "color": "#efde8e",
    "titleJA": "シリカ",
    "ingredientJA": "シリカ（竹エキス）",
  },
  "silica-kids": {
    "weight": 100,
    "labelWeightNumber": 100,
    "labelWeightUnit": "mg",
    "labelWeight": "100mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Silica (Bamboo extract)",
    "sanitisedName": "Silica",
    "color": "#efde8e",
  },
  "selenium": {
    "weight": 0.055,
    "labelWeightNumber": 55,
    "labelWeightUnit": "mcg",
    "labelWeight": "55mcg",
    "NRV": "100%",
    "NRVNumber": 100,
    "ingredient": "Selenium Yeast",
    "title": "Selenium",
    "color": "#326e2e",
    "titleJA": "セレン",
    "ingredientJA": "セレン酵母",
  },
  "selenium-kids": {
    "weight": 0.055,
    "labelWeightNumber": 55,
    "labelWeightUnit": "mcg",
    "labelWeight": "55mcg",
    "NRV": "100%",
    "NRVNumber": 100,
    "ingredient": "Selenium Yeast",
    "sanitisedName": "Selenium Yeast",
    "color": "#326e2e",
  },
  "ginseng": {
    "weight": 100,
    "labelWeightNumber": 100,
    "labelWeightUnit": "mg",
    "labelWeight": "100mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Siberian Ginseng extract 0.8% (Eleutherosides E + B)",
    "title": "Ginseng",
    "color": "#bf5417",
    "titleJA": "朝鮮人参",
    "ingredientJA": "シベリア人参エキス 0.8% (エレウテロサイドE+B)",
  },
  "gingseng": {
    "weight": 100,
    "labelWeightNumber": 100,
    "labelWeightUnit": "mg",
    "labelWeight": "100mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Siberian Ginseng extract 0.8% (Eleutherosides E + B)",
    "color": "#bf5417",
  },
  "nourished-greens": {
    "weight": 100,
    "labelWeightNumber": 100,
    "labelWeightUnit": "mg",
    "labelWeight": "100mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Nourished Greens (Spirulina powder 42.86g/100g, Chlorella 5.707g/100g, Kale Powder 7.14g/100g, Spinach powder 42.86g/100g, Kiwi Powder 1.43g/100g, Vita-algae D 0.003g/100g)",
    "title": "Nourished Greens™",
    "color": "#003810",
    "titleJA": "Nourished Greens™",
    "ingredientJA": "滋養のある野菜 (スピルリナ パウダー 42.86g/100g、クロレラ 5.707g/100g、ケール パウダー 7.14g/100g、ホウレンソウ パウダー 42.86g/100g、キウイ パウダー 1.43g/100g、ビタ藻 D 0.003g/100g)",
  },
  "maca-powder": {
    "weight": 50,
    "labelWeightNumber": 50,
    "labelWeightUnit": "mg",
    "labelWeight": "50mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Maca Root Powder",
    "title": "Maca Powder",
    "color": "#ddc75a",
    "titleJA": "マカパウダー",
    "ingredientJA": "マカの根の粉末",
  },
  "maca-powder-kids": {
    "weight": 50,
    "labelWeightNumber": 50,
    "labelWeightUnit": "mg",
    "labelWeight": "50mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Maca Root Powder",
    "sanitisedName": "Maca Powder",
    "color": "#ddc75a",
  },
  "ashwagandha-extract": {
    "weight": 100,
    "labelWeightNumber": 100,
    "labelWeightUnit": "mg",
    "labelWeight": "100mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Ashwagandha",
    "title": "Ashwagandha Extract",
    "color": "#583030",
    "titleJA": "アシュワガンダエキス",
    "ingredientJA": "アシュワガンダエキス",
  },
  "careflow-mango-powder": {
    "weight": 100,
    "labelWeightNumber": 100,
    "labelWeightUnit": "mg",
    "labelWeight": "100mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Careflow Mango extract",
    "title": "Careflow™ Mango Powder",
    "color": "#c46c1d",
    "titleJA": "Careflow™ マンゴーパウダー",
    "ingredientJA": "Careflow™ マンゴーパウダー",
  },
  "scutellup": {
    "weight": 20,
    "labelWeightNumber": 20,
    "labelWeightUnit": "mg",
    "labelWeight": "20mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Scutell'up",
    "title": "Scutell'up",
    "color": "#8978c2",
    "titleJA": "Scutell'up",
    "ingredientJA": "Scutell'up",
  },
  "scutellup-kids": {
    "weight": 20,
    "labelWeightNumber": 20,
    "labelWeightUnit": "mg",
    "labelWeight": "20mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Scutell'up",
    "sanitisedName": "Scutell'Up",
    "color": "#8978c2",
  },
  "apple-cider-vinegar": {
    "weight": 200,
    "labelWeightNumber": 200,
    "labelWeightUnit": "mg",
    "labelWeight": "200mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Apple Cider Vinegar",
    "title": "Apple Cider Vinegar",
    "color": "#d3bd39",
    "titleJA": "アップルサイダービネガー",
    "ingredientJA": "アップルサイダービネガー",
  },
  "bpl1-ht": {
    "weight": 33.33,
    "labelWeightNumber": 33.33,
    "labelWeightUnit": "mg",
    "labelWeight": "33.33mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "heat-treated B. lactis CECT8145 (BPL1®)",
    "title": "BPL1®",
    "color": "#f2967b",
    "titleJA": "BPL1®",
    "ingredientJA": "BPL1®",
  },
  "5-htp": {
    "weight": 200,
    "labelWeightNumber": 200,
    "labelWeightUnit": "mg",
    "labelWeight": "200mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "5-HTP",
    "title": "5-HTP",
    "color": "#6aa06d",
    "titleJA": "5-HTP",
    "ingredientJA": "5-HTP",
  },
  "vitamin-a-vitamin-e-kids-4": {
    "weight": 0,
    "labelWeightNumber": "",
    "labelWeightUnit": "",
    "labelWeight": "800mcg & 12mg",
    "NRV": "",
    "NRVNumber": "",
    "ingredient": "",
    "sanitisedName": "",
  },
  "vitamin-a-vitamin-e-kids-9": {
    "weight": 0,
    "labelWeightNumber": "",
    "labelWeightUnit": "",
    "labelWeight": "1600mcg & 24mg",
    "NRV": "",
    "NRVNumber": "",
    "ingredient": "",
    "sanitisedName": "",
  },
  "iron-zinc-kids-4": {
    "weight": 0,
    "labelWeightNumber": "",
    "labelWeightUnit": "",
    "labelWeight": "6mg & 5mg",
    "NRV": "",
    "NRVNumber": "",
    "ingredient": "",
    "sanitisedName": "",
  },
  "iron-zinc-kids-9": {
    "weight": 0,
    "labelWeightNumber": "",
    "labelWeightUnit": "",
    "labelWeight": "12mg & 10mg",
    "NRV": "",
    "NRVNumber": "",
    "ingredient": "",
    "sanitisedName": "",
  },
  "folic-acid-vitamin-d3-kids-4": {
    "weight": 0,
    "labelWeightNumber": "",
    "labelWeightUnit": "",
    "labelWeight": "200mcg & 150IU",
    "NRV": "",
    "NRVNumber": "",
    "ingredient": "",
    "sanitisedName": "",
  },
  "folic-acid-vitamin-d3-kids-9": {
    "weight": 0,
    "labelWeightNumber": "",
    "labelWeightUnit": "",
    "labelWeight": "400mcg & 300IU",
    "NRV": "",
    "NRVNumber": "",
    "ingredient": "",
    "sanitisedName": "",
  },
  "coq10-b12-kids-4": {
    "weight": 0,
    "labelWeightNumber": "",
    "labelWeightUnit": "",
    "labelWeight": "15mg & 1.875mg",
    "NRV": "",
    "NRVNumber": "",
    "ingredient": "",
    "sanitisedName": "",
  },
  "coq10-b12-kids-9": {
    "weight": 0,
    "labelWeightNumber": "",
    "labelWeightUnit": "",
    "labelWeight": "30mg & 3.75mg",
    "NRV": "",
    "NRVNumber": "",
    "ingredient": "",
    "sanitisedName": "",
  },
  "vitamin-a-kids-4": {
    "weight": 0.8,
    "labelWeightNumber": 800,
    "labelWeightUnit": "mcg",
    "labelWeight": "800mcg",
    "NRV": "100%",
    "NRVNumber": 100,
    "ingredient": "Vitamin A Acetate",
    "sanitisedName": "Vitamin A",
    "color": "#9f3e52",
  },
  "vitamin-a-kids-9": {
    "weight": 1.6,
    "labelWeightNumber": 1600,
    "labelWeightUnit": "mcg",
    "labelWeight": "1600mcg",
    "NRV": "200%",
    "NRVNumber": 200,
    "ingredient": "Vitamin A Acetate",
    "sanitisedName": "Vitamin A",
    "color": "#9f3e52",
  },
  "vitamin-e-kids-4": {
    "weight": 12,
    "labelWeightNumber": 12,
    "labelWeightUnit": "mg",
    "labelWeight": "12mg",
    "NRV": "100%",
    "NRVNumber": 100,
    "ingredient": "Vitamin E (DL - Alpha Tocopheryl) Acetate",
    "sanitisedName": "Vitamin E",
    "color": "#F5F4F2",
  },
  "vitamin-e-kids-9": {
    "weight": 24,
    "labelWeightNumber": 24,
    "labelWeightUnit": "mg",
    "labelWeight": "24mg",
    "NRV": "200%",
    "NRVNumber": 200,
    "ingredient": "Vitamin E (DL - Alpha Tocopheryl) Acetate",
    "sanitisedName": "Vitamin E",
    "color": "#F5F4F2",
  },
  "iron-kids-4": {
    "weight": 6,
    "labelWeightNumber": 6,
    "labelWeightUnit": "mg",
    "labelWeight": "6mg",
    "NRV": "43%",
    "NRVNumber": 43,
    "ingredient": "Ferrous Citrate",
    "sanitisedName": "Iron",
    "color": "#05617d",
  },
  "iron-kids-9": {
    "weight": 12,
    "labelWeightNumber": 12,
    "labelWeightUnit": "mg",
    "labelWeight": "12mg",
    "NRV": "85%",
    "NRVNumber": 85,
    "ingredient": "Ferrous Citrate",
    "sanitisedName": "Iron",
    "color": "#05617d",
  },
  "zinc-kids-4": {
    "weight": 5,
    "labelWeightNumber": 5,
    "labelWeightUnit": "mg",
    "labelWeight": "5mg",
    "NRV": "50%",
    "NRVNumber": 50,
    "ingredient": "Zinc Citrate",
    "sanitisedName": "Zinc",
    "color": "#F5F4F2",
  },
  "zinc-kids-9": {
    "weight": 10,
    "labelWeightNumber": 10,
    "labelWeightUnit": "mg",
    "labelWeight": "10mg",
    "NRV": "100%",
    "NRVNumber": 100,
    "ingredient": "Zinc Citrate",
    "sanitisedName": "Zinc",
    "color": "#F5F4F2",
  },
  "folic-acid-kids-4": {
    "weight": 0.2,
    "labelWeightNumber": 200,
    "labelWeightUnit": "mcg",
    "labelWeight": "200mcg",
    "NRV": "100%",
    "NRVNumber": 100,
    "ingredient": "Folic acid (B9)",
    "sanitisedName": "Folic acid",
    "color": "#4db160",
  },
  "folic-acid-kids-9": {
    "weight": 0.4,
    "labelWeightNumber": 400,
    "labelWeightUnit": "mcg",
    "labelWeight": "400mcg",
    "NRV": "200%",
    "NRVNumber": 200,
    "ingredient": "Folic acid (B9)",
    "sanitisedName": "Folic acid",
    "color": "#4db160",
  },
  "vitamin-d3-kids-4": {
    "weight": 3.75,
    "labelWeightNumber": 150,
    "labelWeightUnit": "IU",
    "labelWeight": "150IU",
    "NRV": "75%",
    "NRVNumber": 75,
    "ingredient": "Vita-algae D3",
    "sanitisedName": "Vitamin D3",
    "color": "#F5F4F2",
  },
  "vitamin-d3-kids-9": {
    "weight": 7.5,
    "labelWeightNumber": 300,
    "labelWeightUnit": "IU",
    "labelWeight": "300IU",
    "NRV": "150%",
    "NRVNumber": 150,
    "ingredient": "Vita-algae D3",
    "sanitisedName": "Vitamin D3",
    "color": "#F5F4F2",
  },
  "coq10-kids-4": {
    "weight": 15,
    "labelWeightNumber": 15,
    "labelWeightUnit": "mg",
    "labelWeight": "15mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "COQ10",
    "sanitisedName": "CoQ10",
    "color": "#f4991c",
  },
  "coq10-kids-9": {
    "weight": 30,
    "labelWeightNumber": 30,
    "labelWeightUnit": "mg",
    "labelWeight": "30mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "COQ10",
    "sanitisedName": "CoQ10",
    "color": "#f4991c",
  },
  "b12-kids-4": {
    "weight": 0.001875,
    "labelWeightNumber": 1.875,
    "labelWeightUnit": "mcg",
    "labelWeight": "1.875mcg",
    "NRV": "75%",
    "NRVNumber": 75,
    "ingredient": "Vitamin B12",
    "sanitisedName": "Vitamin B12",
    "color": "#F5F4F2",
  },
  "b12-kids-9": {
    "weight": 0.0025,
    "labelWeightNumber": 2.5,
    "labelWeightUnit": "mcg",
    "labelWeight": "2.5mcg",
    "NRV": "104%",
    "NRVNumber": 104,
    "ingredient": "Vitamin B12",
    "sanitisedName": "Vitamin B12",
    "color": "#F5F4F2",
  },
  "vitamin-c-kids-4": {
    "weight": 48,
    "labelWeightNumber": 48,
    "labelWeightUnit": "mg",
    "labelWeight": "48mg",
    "NRV": "60%",
    "NRVNumber": 60,
    "ingredient": "Vitamin C",
    "sanitisedName": "Vitamin C",
    "color": "#f39f22",
  },
  "vitamin-c-kids-9": {
    "weight": 96,
    "labelWeightNumber": 96,
    "labelWeightUnit": "mg",
    "labelWeight": "96mg",
    "NRV": "120%",
    "NRVNumber": 120,
    "ingredient": "Vitamin C",
    "sanitisedName": "Vitamin C",
    "color": "#f39f22",
  },
  "k2-vital-delta-kids-4": {
    "weight": 0.0375,
    "labelWeightNumber": 37.5,
    "labelWeightUnit": "mcg",
    "labelWeight": "37.5mcg",
    "NRV": "50%",
    "NRVNumber": 50,
    "ingredient": "K2 Vital Delta",
    "sanitisedName": "K2 Vital Delta",
    "color": "#e61572",
  },
  "k2-vital-delta-kids-9": {
    "weight": 0.075,
    "labelWeightNumber": 75,
    "labelWeightUnit": "mcg",
    "labelWeight": "75mcg",
    "NRV": "100%",
    "NRVNumber": 100,
    "ingredient": "K2 Vital Delta",
    "sanitisedName": "K2 Vital Delta",
    "color": "#e61572",
  },
  "inositol": {
    "weight": 300,
    "labelWeightNumber": 300,
    "labelWeightUnit": "mg",
    "labelWeight": "300mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Inositol",
    "sanitisedName": "Inositol",
    "title": "Inositol",
    "color": "#eae8d3",
    "titleJA": "イノシトール",
  },
  "soy-isoflavones": {
    "weight": 50,
    "labelWeightNumber": 50,
    "labelWeightUnit": "mg",
    "labelWeight": "50mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Soy Isoflavones",
    "sanitisedName": "Soy Isoflavones",
    "title": "Soy Isoflavones",
    "color": "#e2b46f",
    "ingredientJA": "大豆イソフラボン",
  },
  "vegan-vitamin-d3": {
    "weight": 0.05,
    "labelWeightNumber": 2000,
    "labelWeightUnit": "IU",
    "labelWeight": "2000IU",
    "NRV": "1000%",
    "NRVNumber": 1000,
    "ingredient": "Vegan Vitamin D3",
    "sanitisedName": "Vegan Vitamin D3",
    "title": "Vegan Vitamin D3",
    "color": "#cc5275",
    "titleJA": "ヴィーガン ビタミンD3",
    "ingredientJA": "ヴィーガン ビタミンD3",
  },
  "vitamin-d2": {
    "weight": 0.05,
    "labelWeightNumber": 300,
    "labelWeightUnit": "IU",
    "labelWeight": "300IU",
    "NRV": "150%",
    "NRVNumber": 150,
    "ingredient": "Vegan Vita-algae D3",
    "sanitisedName": "Vegan Vita-algae D3",
    "title": "Vegan Vita-algae D3",
    "color": "#cc5275",
    "titleJA": "ビーガンビタ藻D3",
    "ingredientJA": "ビーガンビタ藻D3",
  },
  "lutemax": {
    "weight": 12,
    "labelWeightNumber": 12,
    "labelWeightUnit": "mg",
    "labelWeight": "12mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Lutemax",
    "sanitisedName": "Lutemax",
    "title": "Lutemax",
    "color": "#ff5918",
    "titleJA": "ルテマックス2020",
  },
  "iodine": {
    "weight": 0.15,
    "labelWeightNumber": 0.15,
    "labelWeightUnit": "mcg",
    "labelWeight": "150mcg",
    "NRV": "100%",
    "NRVNumber": 100,
    "ingredient": "Potassium Iodide",
    "sanitisedName": "Iodine",
    "title": "Iodine",
    "color": "#bbc8d9",
    "titleJA": "ヨウ素",
    "ingredientJA": "ヨウ化カリウム",
  },
  "ovoderm": {
    "weight": 300,
    "labelWeightNumber": 300,
    "labelWeightUnit": "mg",
    "labelWeight": "300mg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Ovoderm",
    "sanitisedName": "Ovoderm",
    "title": "Ovoderm",
    "color": "#638452",
  },
  "biotin": {
    "weight": 0.050,
    "labelWeightNumber": 50,
    "labelWeightUnit": "mcg",
    "labelWeight": "50mcg",
    "NRV": "N/A",
    "NRVNumber": 0,
    "ingredient": "Biotin",
    "sanitisedName": "Biotin",
    "title": "Biotin",
    "color": "#456349",
  }
};

export default nourishmentData;
